(()=>{if(window.__ValuraaFinalConcept)return;window.__ValuraaFinalConcept=true;
const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
const setDockFinderState=()=>{
  if(location.pathname!=='/')return;
  const dock=document.querySelector('[data-vfdock]');
  const finder=dock?.querySelector('[data-vfdock-finder-link]');
  if(!dock||!finder)return;
  const section=document.querySelector('#vf-home-finder');
  if(!section)return;
  const observer=new IntersectionObserver(entries=>{
    const visible=entries.some(e=>e.isIntersecting);
    if(visible){dock.querySelectorAll('[aria-current="page"]').forEach(n=>n.removeAttribute('aria-current'));finder.setAttribute('aria-current','page')}
    else if(scrollY<Math.max(80,section.offsetTop-500)){finder.removeAttribute('aria-current');dock.querySelector('[data-vfdock-home]')?.setAttribute('aria-current','page')}
  },{threshold:.22});
  observer.observe(section);
};
setDockFinderState();
document.addEventListener('shopify:section:load',()=>{setDockFinderState()});
document.addEventListener('click',e=>{
  const stickyBuy=e.target.closest('[data-vf-sticky-buy]');
  if(stickyBuy){
    e.preventDefault();
    const productRoot=stickyBuy.closest('[data-vf-product]');
    const dynamic=productRoot?.querySelector('.shopify-payment-button__button');
    if(dynamic&&!stickyBuy.disabled){navigator.vibrate?.(4);dynamic.click()}
    return;
  }
  const a=e.target.closest('a[href^="#"],a[href*="#vf-home-finder"]');if(!a)return;
  const u=new URL(a.href,location.href);if(u.origin!==location.origin||u.pathname!==location.pathname||!u.hash)return;
  const target=document.querySelector(u.hash);if(!target)return;e.preventDefault();target.scrollIntoView({behavior:reduced?'auto':'smooth',block:'start'});history.replaceState(null,'',u.hash);
});
})();